import { accountApi } from "../../config/apiConfig";
import { ResignReason, ResignReasonListResponse } from "../../types/onboarding";

// GET /admin/resign-reasons[?activeOnly=true]
export const listResignReasons = async (
  activeOnly = false
): Promise<ResignReasonListResponse> => {
  const query = activeOnly ? "?activeOnly=true" : "";
  const response = await accountApi.get(`admin/resign-reasons${query}`);
  return response.data;
};

// POST /admin/resign-reasons — code must be unique (409 REASON_CODE_EXISTS).
export const createResignReason = async (payload: {
  code: string;
  display_label: string;
}): Promise<ResignReason> => {
  const response = await accountApi.post("admin/resign-reasons", payload);
  return response.data;
};

// PUT /admin/resign-reasons/{code} — update display label only.
export const updateResignReason = async (
  code: string,
  displayLabel: string
): Promise<ResignReason> => {
  const response = await accountApi.put(`admin/resign-reasons/${code}`, {
    display_label: displayLabel,
  });
  return response.data;
};

// DELETE /admin/resign-reasons/{code} — soft-delete (deactivate).
export const deactivateResignReason = async (code: string): Promise<void> => {
  await accountApi.delete(`admin/resign-reasons/${code}`);
};
